import React from "react";
import { Col, Container, Row } from "reactstrap";

const PrivacyPolicy = () => {
  return (
    <section id="privacy-policy" className="accordion-flush">
      <Container>
        <Row>
          <Col lg="12" xs="12" className="mb-10">
            <div className="course__top d-flex justify-content-between align-items-center flex-wrap">
              <div className="course__top__left w-60">
                <h2>Privacy Policy</h2>

                <h3>Last Updated: October 23, 2024</h3>
              </div>

              <div className="w-50 text-end">
                {/* <button className="btn">See All</button>  */}
              </div>
            </div>
          </Col>
          <Col lg="8" md="12" sm="12">
            <p>
              At Seed to Tree Online Academy, we are committed to protecting
              your privacy and ensuring the security of your personal
              information. This Privacy Policy outlines our practices concerning
              the collection, use, and disclosure of your data when you visit
              our website or use our services. By accessing or using Seed to
              Tree Online Academy's website and services, you agree to the terms
              and practices described in this policy.
            </p>
            <p>
              By using Seed to Tree Online Academy's website and services, you
              consent to the practices described in this Privacy Policy. Please
              review this policy regularly for updates.
            </p>
          </Col>
          <Col lg="12" md="12" sm="12">
            <div className="accordion accordion-flush">
              {/* 1 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne"
                    aria-expanded="false"
                    aria-controls="flush-collapseOne"
                  >
                    <h3>1. Information We Collect</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseOne"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    <h4>1.1 Personal Information We may collect personally</h4>
                    <p>
                      identifiable information, such as your name, email
                      address, postal address, phone number, and payment details
                      when you register for our courses, subscribe to our
                      newsletter, or contact us through our website.
                    </p>
                    <h4>1.2 Non-Personal Information</h4>
                    <p>
                      We may collect non-personal information such as browser
                      type, operating system, IP address, and usage data to
                      improve our website's functionality and user experience.
                    </p>
                  </div>
                </div>
              </div>
              {/* 2 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTwo"
                    aria-expanded="false"
                    aria-controls="flush-collapseTwo"
                  >
                    <h3>2. How We Use Your Information</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseTwo"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    <h4>2.1 Personal Information</h4>
                    <div>
                      We use your personal information for the following
                      purposes:
                      <ol>
                        <li>
                          To provide our educational services and courses to
                          you.
                        </li>
                        <li>
                          To send you important updates, newsletters, and
                          marketing communications.
                        </li>
                        <li>
                          To process payments and billing related to our
                          services.
                        </li>
                        <li>
                          To respond to your inquiries and provide customer
                          support.
                        </li>
                      </ol>
                    </div>
                    <h4> 2.2 Non-Personal Information</h4>
                    <p>
                      Non-personal information is primarily used for analyzing
                      website usage trends, improving our website, and enhancing
                      our services.
                    </p>
                  </div>
                </div>
              </div>
              {/* 3 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseThree"
                    aria-expanded="false"
                    aria-controls="flush-collapseThree"
                  >
                    <h3>3. Data Sharing</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseThree"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    {/* <h4></h4> */}
                    <div>
                      We do not sell or share your personal information with
                      third parties without your explicit consent, except as
                      described below:
                      <ol>
                        <li>
                          We may share your information with trusted service
                          providers who assist us in operating our website and
                          delivering our services, but they are bound by strict
                          confidentiality agreements.
                        </li>
                        <li>
                          We may disclose your information if required by law or
                          to protect our rights and the safety of our users.
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
              {/* 4 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseFour"
                    aria-expanded="false"
                    aria-controls="flush-collapseFour"
                  >
                    <h3>4. Security</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseFour"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    {/* <h4></h4> */}
                    <p>
                      We take reasonable measures to protect your personal
                      information from unauthorized access, disclosure,
                      alteration, or destruction. However, no online data
                      transmission or storage can be guaranteed to be 100%
                      secure.
                    </p>
                  </div>
                </div>
              </div>
              {/* 5 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseFive"
                    aria-expanded="false"
                    aria-controls="flush-collapseFive"
                  >
                    <h3>5. Your Choices</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseFive"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    {/* <h4></h4> */}
                    <div>
                      You have the following choices regarding your personal
                      information:
                      <ol>
                        <li>
                          {" "}
                          You can access, correct, or update your personal
                          information by logging into your account.
                        </li>
                        <li>
                          {" "}
                          You can opt out of receiving marketing communications
                          from us at any time by following the instructions in
                          the communication.
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
              {/* 6 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseSix"
                    aria-expanded="false"
                    aria-controls="flush-collapseSix"
                  >
                    <h3>6. Cookies and Tracking</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseSix"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    {/* <h4></h4> */}
                    <p>
                      We use cookies and similar tracking technologies to
                      improve your browsing experience on our website. You can
                      manage your cookie preferences in your browser settings.
                    </p>
                  </div>
                </div>
              </div>
              {/* 7 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseSeven"
                    aria-expanded="false"
                    aria-controls="flush-collapseSeven"
                  >
                    <h3>7. Children's Privacy</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseSeven"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    {/* <h4></h4> */}
                    <p>
                      Our services are not intended for individuals under the
                      age of 13. We do not knowingly collect personal
                      information from children.
                    </p>
                  </div>
                </div>
              </div>
              {/* 8 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseEight"
                    aria-expanded="false"
                    aria-controls="flush-collapseEight"
                  >
                    <h3>8. Changes to this Privacy Policy</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseEight"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    {/* <h4></h4> */}
                    <p>
                      We may update this Privacy Policy from time to time to
                      reflect changes in our practices or for legal reasons. We
                      will notify you of any material changes by posting a
                      notice on our website or sending you an email.
                    </p>
                  </div>
                </div>
              </div>
               {/* 9 */}
               <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseNine"
                    aria-expanded="false"
                    aria-controls="flush-collapseNine"
                  >
                    <h3>9. Third Party Links</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseNine"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    {/* <h4></h4> */}
                    <p>
                    Our website includes links to external blogs hosted on Blogger. When you click on these links, you will be redirected to Blogger, which is a platform provided by Google. Please note that your interactions on Blogger are subject to Google’s Privacy Policy, which you can read here. We do not control the privacy practices of third-party sites.
                    </p>{" "}
                  </div>
                </div>
              </div>
              {/* 10 */}
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTen"
                    aria-expanded="false"
                    aria-controls="flush-collapseNine"
                  >
                    <h3>10. Contact Us</h3>
                  </button>
                </h2>
                <div
                  id="flush-collapseTen"
                  className="accordion-collapse collapse"
                  data-bs-parent="#privacy-policy"
                >
                  <div className="accordion-body">
                    {/* <h4></h4> */}
                    <p>
                      If you have any questions or concerns regarding our
                      Privacy Policy, please contact us at
                      seedtotree.info@gmail.com
                    </p>{" "}
                  </div>
                </div>
              </div>
            </div>
          </Col>

       
        </Row>
      </Container>
    </section>
  );
};

export default PrivacyPolicy;
